import React, { useState } from "react";
import PropTypes from "prop-types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, Stack, Card, CardContent, Typography } from "@mui/material";
import { withTranslation } from "react-i18next";

import CommentBox from "Components/Common/CommentBox";
import CommentInput from "Components/Common/CommentInput";

import { usePostAdminBuildingObservationCommentMutation } from "apis/ApplicationRequestComment";

const AdminDiscussionForBuildingObservation = ({
  adminComments,
  isResolved,
  t,
  inspectionObservationId,
}) => {
  const [addComment] = usePostAdminBuildingObservationCommentMutation();

  const [openAdminDiscussion, setOpenAdminDiscussion] = useState(true);

  const handleDiscussionCollapse = () => {
    setOpenAdminDiscussion(!openAdminDiscussion);
  };

  const addNewComment = async (comment, inspectionObservationId) => {
    try {
      await addComment({
        comment,
        inspectionObservationId,
      });
    } catch (error) {}
  };

  return (
    <>
      <div
        className="fs-4 fw-semibold mb-3 border-bottom"
        onClick={handleDiscussionCollapse}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <div>{t("Admin Discussion")}</div>{" "}
          <p>{openAdminDiscussion ? <ExpandLess /> : <ExpandMore />}</p>
        </Stack>
      </div>
      <Collapse in={openAdminDiscussion} timeout="auto" unmountOnExit>
        {!isResolved && (
          <CommentInput
            handleSubmit={addNewComment}
            isFireSafety
            inspectionObservationId={inspectionObservationId}
          />
        )}

        {adminComments.length ? (
          adminComments.map(({ comment, createdAt, name, role }, index) => (
            <CommentBox
              comment={comment}
              name={name}
              role={role}
              createdAt={createdAt}
              key={index}
            />
          ))
        ) : (
          <Card variant="outlined" className="mt-2 p-0">
            <CardContent className="pt-1">
              <Typography color="GrayText" gutterBottom>
                {t("No comment")}
              </Typography>
            </CardContent>
          </Card>
        )}
      </Collapse>
    </>
  );
};

AdminDiscussionForBuildingObservation.propTypes = {
  inspectionObservationId: PropTypes.number,
  adminComments: PropTypes.array,
  isResolved: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(AdminDiscussionForBuildingObservation);
